import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatchService } from '../match.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-set-limit',
  templateUrl: './set-limit.component.html',
  styleUrls: ['./set-limit.component.css']
})
export class SetLimitComponent implements OnInit, OnDestroy {
  isLoading = false;
  websites: any[] = [
    { key: 'All', value: 'all' },
    //{ key: 'BSF44', value: 'http://bsf44.net' },
    //{ key: 'Apnabet', value: 'http://apnabet247.com' },
    //{ key: '4bet', value: 'http://4bet.in' },
    //{ key: 'EarthBet', value: 'http://earthbet.in' },
    //{ key: 'Bethonk', value: 'http://bethonk.com' },
    //{ key: 'Betrok', value: 'http://betrok.com' },
    { key: 'DiamondExch', value: 'https://diamondexchange.in' },
    { key: 'PurpleBook', value: 'https://ad.purplebook9.com' },
    { key: 'Diamond9', value: 'https://Diamondexch9.site' }
  ];
  limitForm: FormGroup;
  submitted = false;
  id: any;
  sport: any;
  private routeSubs: Subscription;
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
    private matchService: MatchService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.routeSubs = this.route.paramMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.has('id') && paramMap.has('sport')) {
        this.id = paramMap.get('id');
        this.sport = paramMap.get('sport');
        this.isLoading = false;
        if (this.sport == '4') {
          this.limitForm = this.formBuilder.group({
            sites: ['all', Validators.required],
            oddsMin: [100, Validators.required],
            oddsMax: [10000, Validators.required],
            oddsProfitLoss: [200000, [Validators.required]],
            bookMin: [100, Validators.required],
            bookMax: [200000, Validators.required],
            bookProfitLoss: [2000000, [Validators.required]],
            fancyMin: [100, Validators.required],
            fancyMax: [200000, Validators.required],
            fancyProfitLoss: [1000000, [Validators.required]]
          });
        }
        else {
          this.limitForm = this.formBuilder.group({
            sites: ['all', Validators.required],
            oddsMin: [100, Validators.required],
            oddsMax: [5000, Validators.required],
            oddsProfitLoss: [50000, [Validators.required]],
            bookMin: [100, Validators.required],
            bookMax: [100000, Validators.required],
            bookProfitLoss: [500000, [Validators.required]],
            fancyMin: [100, Validators.required],
            fancyMax: [200000, Validators.required],
            fancyProfitLoss: [500000, [Validators.required]]
          });
        }
      }
    });
  }

  get f() { return this.limitForm.controls; }

  onSubmit() {
    return;
    this.submitted = true;
    if (this.limitForm.invalid) {
      return;
    }

    swal.fire({
      title: 'Are You Sure Want to Set limit ?',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.isLoading = true;
        this.setLimit();
      }
      else {
        this.submitted = false;
      }
    });
  }


  setLimit() {
    this.matchService.setLimit(this.id, this.limitForm.value).subscribe(data => {
      this.submitted = false;
      this.isLoading = false;
      this.msgSuccess();
    }, error => {
      this.isLoading = false;
      this.msgFailure();
    });
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Update!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  ngOnDestroy() {
    this.routeSubs && this.routeSubs.unsubscribe();
  }
}
